module.exports = __webpack_public_path__ + "media/KikiLK.40a487eb.mp3";